import type * as types from './types';


const initialState = {
    status: 'IDLE',
    amountSought: 20000,
    country: 'FR',
    siren: '',
    typeInvestment: null,
    amountCA: 1,
    amountRN: 1,
    isUploading: false,
    successEligibleTest: undefined,
    invalidEligibleTest: undefined,
};

type EligibleAction = {
    type: typeof types[keyof typeof types];
    payload?: Partial<types.EligibleState>;
};

export default function eligibleReducer(state = initialState, action: EligibleAction) {
    const { type, payload } = action;
    switch (type) {
        case 'RESET_CALL_ELIGIBLE':
            return {
                ...state,
                isUploading: false,
                successEligibleTest: undefined,
                invalidEligibleTest: undefined,
            };
        case 'SEND_TEST_ELIGIBLE':
            return {
                ...state, isUploading: true, successEligibleTest: undefined, invalidEligibleTest: undefined,
            };
        case 'TEST_ELIGIBLE_SUCCESS':
            return { ...state, isUploading: false, successEligibleTest: true };
        case 'TEST_ELIGIBLE_FAILED':
            return { ...state, isUploading: false, successEligibleTest: false };
        case 'TEST_ELIGIBLE_INVALID':
            return {
                ...state, isUploading: false, successEligibleTest: false, invalidEligibleTest: true,
            };
        case 'UPDATE_SIMULATION_DATA':
            return { ...state, ...payload, status: 'SUCCEEDED' };
        case 'UPDATE_PROJECT_ID':
            return { ...state, id: payload };
        case 'UPDATE_PROJECT_NAME':
            return { ...state, projectName: payload };
        case 'UPDATE_AMOUNT_SOUGHT':
            return { ...state, amountSought: payload };
        case 'UPDATE_COUNTRY':
            return { ...state, country: payload };
        case 'UPDATE_SIREN':
            return { ...state, siren: payload };
        case 'UPDATE_TYPE_INVESTMENT':
            return { ...state, typeInvestment: payload };
        case 'UPDATE_AMOUNT_CA':
            return { ...state, amountCA: payload };
        case 'UPDATE_AMOUNT_RN':
            return { ...state, amountRN: payload };
        default:
            return { ...state };
    }
};
